import { HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  urlsToNotUse = [
      'source-currencies',
      'destination-currencies/',
      'fees',
      'conversions',
      'buycurrencies',
      'buyfees',
      'buyrates',
      'HTMLPost/HTMLMessenger'
  ]

  constructor(private authService : AuthService, private router : Router) { }

  intercept(req, next){
    let jwtInString = localStorage.getItem('res')
    let jwt = JSON.parse(jwtInString)?.jwt
    if (this.isValidRequestForInterceptor(req.url))
           return next.handle(req);
    if(jwt){
      let requestWithToken = req.clone({
        setHeaders : {
          Authorization: `Bearer ${jwt}`
        }
      })

      return next.handle(requestWithToken).pipe( tap(() => {},
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
          return;
          }
          window.localStorage.removeItem('res')
          this.router.navigateByUrl('/')
        }
      }));
      // return next.handle(requestWithToken)
    }
    else{
      let request = req.clone({})
      return next.handle(request)
    }
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    let endPoint = requestUrl.split('.com/')[1]?.split('?')[0]
    if(this.urlsToNotUse.includes(endPoint))
      return true
    else  
      return false
  }
}
